module.exports = __webpack_public_path__ + "img/otopack250-inactive.081b3a95.svg";